import React, { useEffect, useState } from 'react';
import { Flame, Trophy } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LangContext';

export const StreakRing = () => {
  const { user } = useAuth();
  const { t } = useLang();
  const [s, setS] = useState(null);

  useEffect(() => {
    if (!user) { setS(null); return; }
    api.get('/streak').then(({ data }) => setS(data)).catch(() => {});
  }, [user]);

  if (!s || s.tracked_total === 0) return null;
  const pct = Math.min(1, s.count / s.goal);
  const r = 34, c = 2 * Math.PI * r;
  const done = s.count >= s.goal;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-6" data-testid="streak-ring">
      <div className="rounded-2xl border border-border bg-card p-5 flex items-center gap-5">
        <div className="relative w-20 h-20 shrink-0" role="img" aria-label={`${s.count} of ${s.goal} applications moved forward this month`}>
          <svg viewBox="0 0 80 80" className="w-20 h-20 -rotate-90">
            <circle cx="40" cy="40" r={r} fill="none" stroke="hsl(var(--secondary))" strokeWidth="8" />
            <circle cx="40" cy="40" r={r} fill="none" stroke={done ? '#16A34A' : '#C26227'} strokeWidth="8" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)} style={{ transition: 'stroke-dashoffset 900ms ease-out' }} />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center font-bold text-lg" style={{fontFamily: 'Lexend'}} data-testid="streak-count">{s.count}<span className="text-xs text-muted-foreground font-normal">/{s.goal}</span></div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold flex items-center gap-2" style={{fontFamily: 'Lexend'}}>{done ? <Trophy className="w-4 h-4 text-[#16A34A]" /> : <Flame className="w-4 h-4 text-[#C26227]" />} {t('This month')}: {s.count} {t('applications moved forward')}</div>
          <p className="text-sm text-muted-foreground mt-0.5">{done ? t('Goal reached — brilliant work.') : t('Keep the momentum — one more this week!')}</p>
          {s.items.length > 0 && <p className="text-xs text-muted-foreground mt-1 truncate">{s.items.map((i) => i.program_name).join(' · ')}</p>}
        </div>
      </div>
    </section>
  );
};
